import {MedicalOrganizationVaccine} from "../../../types/MedicalOrganizationVaccine";

export const filterMedicalOrganizationVaccines = ({
  medicalOrganizationVaccines,
  keyword,
  selectedVaccineTypes,
  selectedRegions,
}) => (
  medicalOrganizationVaccines?.filter((medicalOrganizationVaccine: MedicalOrganizationVaccine) => {
    const trimmedKeyword = keyword.trim();
    return (
      selectedVaccineTypes.some(
        (element: string) => (
            medicalOrganizationVaccine?.vaccines?.includes(element))
          || selectedVaccineTypes[0] === '不限'
      ) &&
      (
        selectedRegions.includes(medicalOrganizationVaccine?.region)
        || selectedRegions[0] === '不限'
      ) &&
      (
        trimmedKeyword === ''
        || medicalOrganizationVaccine?.name?.includes(trimmedKeyword)
        || medicalOrganizationVaccine?.address?.includes(trimmedKeyword)
      )
    )
  })
);